<script setup lang="ts">
import type { Component } from 'vue'
import { AffiliatePoint, BuildingOffice, DocumentInvoice, LayananFitur, PartnerKasheer, UserCircle } from '~/components/icons'

const props = defineProps<{
  icon: string
  title: string
  description: string
  to: string
}>()

const iconMap: Record<string, Component> = {
  UserCircle,
  BuildingOffice,
  DocumentInvoice,
  LayananFitur,
  AffiliatePoint,
  PartnerKasheer,
}

const iconComponent = computed(() => iconMap[props.icon])
</script>

<template>
  <NuxtLink :to="to" class="group block">
    <Card class="hover:border-primary/30 transition-colors h-full space-y-4">
      <component :is="iconComponent" class="size-12 shrink-0" />
      <div>
        <h3 class="font-semibold group-hover:text-primary transition-colors">
          {{ title }}
        </h3>
        <p class="text-sm mt-1 truncate group-hover:text-primary transition-colors">
          {{ description }}
        </p>
      </div>
    </Card>
  </NuxtLink>
</template>
